import { render, staticRenderFns } from "./WeChatNotifyNotice.vue?vue&type=template&id=1754de96&scoped=true&"
import script from "./WeChatNotifyNotice.vue?vue&type=script&lang=js&"
export * from "./WeChatNotifyNotice.vue?vue&type=script&lang=js&"
import style0 from "./WeChatNotifyNotice.vue?vue&type=style&index=0&id=1754de96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1754de96",
  null
  
)

export default component.exports